const buttonsBlogs = document.querySelectorAll(".blogs-navigation__li");
const currentSlug = window.location.pathname.split("/").filter(Boolean).pop();

buttonsBlogs.forEach((button) => {
  const blog = button.getAttribute("data-slug");
  console.log(blog + currentSlug);
  if (blog === currentSlug) {
    button.classList.add("active");
  }
});
